import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Dialog, DialogActions, DialogTitle, FormControlLabel, Switch, Typography } from '@mui/material';
import { Iconify } from '../../../components';
import { clearSimilarLeadsData, getSimilarDuplicateLeads, updateSelectedSimilarLeads } from '../../../redux/slices/duplicateLeads';
import { dispatch, useSelector } from '../../../redux/store';
import { useToggle } from '../../../hooks';
import SimilarLeadPopupContent from './SimilarLeadPopupContent';
import {
    infoIconBox,
    similarLeadViewCard,
    similarLeadsButton,
} from '../../../styles/OverView';

const SimilarLeadWarningPopup = ({ dialogClose, type }) => {
    const { practiceId } = useSelector((state) => state.practiceTreatmentList);
    const [isArchiveChecked, setIsArchiveChecked] = useState(false);
    const {
        leadDetail, followLead
    } = useSelector((state) => state.lead);

    const {
        toggle: similarLeadOpen,
        onOpen: onSimilarLeadOpen,
        onClose: onCloseSimilarLead
    } = useToggle();

    const handleSimilarLeadsClose = () => {
        onCloseSimilarLead();
        dispatch(updateSelectedSimilarLeads({ leadIds: [] }));
        dispatch(clearSimilarLeadsData());
        if (type === 'DialogPopup') {
            dialogClose();
        }
    };

    const handleSimilarLeadPopupClose = () => {
        onCloseSimilarLead();
        dispatch(updateSelectedSimilarLeads({ leadIds: [] }));
        dispatch(clearSimilarLeadsData());
    };

    const handleArchiveFilter = (e) => {
        setIsArchiveChecked(e.target.checked);
        dispatch(updateSelectedSimilarLeads({ leadIds: [] }));
        if (practiceId) {
            const payload = {
                practiceId, limit: 10, offset: 0,
                needArchivedData: e.target.checked,
            };
            dispatch(getSimilarDuplicateLeads({ ...payload, leadId: leadDetail?.id || followLead?.id }));
        }
    };

    return <>
        {(leadDetail?.is_duplicate || followLead?.is_duplicate) && <Box sx={similarLeadViewCard}>
            <Box sx={{ ...infoIconBox, borderRadius: '8px', bgcolor: 'rgba(255, 72, 66, 0.12)' }}>
                <Iconify icon={'solar:users-group-rounded-bold-duotone'} sx={{ color: '#B72136' }} width={18} height={18} />
            </Box>
            <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#B72136', flex: 1 }}>
                Duplicate leads detected
            </Typography>
            <Button size='small' sx={similarLeadsButton} onClick={() => onSimilarLeadOpen()}>
                Compare <Iconify icon={'mdi:arrow-right-thin'} sx={{ color: '#B72136', ml: 0.5 }} width={16} height={16} />
            </Button>
        </Box>}
        <Dialog
            fullWidth
            maxWidth={'lg'}
            open={similarLeadOpen}
            onClose={handleSimilarLeadsClose}
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <DialogTitle>Similar Leads</DialogTitle>
                <Box sx={{ display: 'flex', justifyContent: 'end', m: '12px 24px' }}>
                    <FormControlLabel control={
                        <Switch checked={isArchiveChecked}
                            onChange={handleArchiveFilter}
                            inputProps={{ 'aria-label': 'controlled' }} />
                    } labelPlacement="start" label="Include Archived Data" />
                </Box>
            </Box>
            <SimilarLeadPopupContent
                checked={isArchiveChecked}
                leadId={leadDetail?.id || followLead?.id}
                handleCloseSimilarLeads={handleSimilarLeadsClose}
                overviewTab={'leadDetail'}
            />
            <DialogActions>
                <Button onClick={handleSimilarLeadPopupClose}>Close</Button>
            </DialogActions>
        </Dialog>
    </>;
};

export default SimilarLeadWarningPopup;

SimilarLeadWarningPopup.propTypes = {
    dialogClose: PropTypes.func,
    type: PropTypes.string
};